// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"60064efb","348":"e71e78c3","546":"1c20ae95","558":"0afea813","571":"d9a98a91"}[chunkId] + ".chunk.js";
};